<template>
  <div>

     <div v-if="loading">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Update"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>

              <form-group label="Status">
               <b-form-select 
               v-model="scheme.status" :options="[
               {'text':'Active','value':'Active'},
               {'text':'Cancelled','value':'Cancelled'},
               {'text':'Completed','value':'Completed'}]"></b-form-select>
            </form-group>


            <form-group label="Name" :required="true">
              <input
                ref="name"
                type="text"
                @blur="$v.scheme.name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.scheme.name.$error }"
                v-model="scheme.name"
              />
              <div class="invalid-feedback" v-if="!$v.scheme.name.required">
               Enter name
              </div>
            </form-group>

            <form-group label="Description">
               <textarea-autosize
                class="form-control"
                v-model="scheme.description"
              />
            </form-group>

             <form-group label="Balance brought forward" >
              <input
                type="number"
                class="form-control"
                v-model="scheme.brought_forward"
              />
            </form-group>

            <form-group label="Limit Collector to contributors" >
              <b-form-checkbox
                switch
                v-model="scheme.limit_collectors_to_their_contributors"
                value="1"
                unchecked-value="0"
              >
              </b-form-checkbox>
            </form-group>

            <hr>

             <form-group label="Plans" :required="true">
               
               <table class="table table-sm table-bordered" v-if="scheme.plans.length > 0">
                <thead>
                  <tr class="bg-light">
                    <th>Name</th>
                    <th>Frequency</th>
                    <th class="text-right">Amount</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tr v-for="plan in scheme.plans" :key="plan.id">
                  <td>{{ plan.name }}</td>
                  <td>{{ plan.contribution_frequency }}</td>
                  <td class="text-right">
                    <input
                      v-if="plan.contribution_frequency != 'Ad hoc'"
                      style="max-width:100px;"
                      type="number"
                      class="form-control"
                      v-model="plan.amount"
                    />
                  </td>
                  <td class="text-right">

                    <i
                      v-if="plan.id != null "
                      @click="removePlan(plan.id)"
                      class="lni lni-trash text-danger pointer"
                    ></i>
                   
                  </td>
                </tr>
              </table>

              <h6 class="text-info">Add a plan</h6>

               <form-group label="Name" >
                  <input
                  type="text"
                  class="form-control"
                  v-model="newPlan.name"
                />
              </form-group>

              <form-group label="Frequency" >
                   <b-form-select v-model="newPlan.contribution_frequency" :options="contribution_frequencies"></b-form-select>
              </form-group>

              <form-group label="Amount" v-if="newPlan.contribution_frequency != 'Ad hoc'">
                  <input
                  type="number"
                  class="form-control"
                  v-model="newPlan.amount"
                />
              </form-group>

              <span class="btn btn-sm btn-info float-right" @click="addPlan()">Add Plan</span>

               
            </form-group>

            <hr>

          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import schemeRepo from '@/api/repos/schemeRepo'
import { required } from 'vuelidate/lib/validators'
import formBase from '@/components/common/FormBase'
import formGroup from '@/components/common/FormGroup'


export default {
  components: {
    formBase,
    formGroup
  },

  validations: {
    scheme: {
      name: {
        required
      },
      
    }
  },

  mounted () {
    this.getScheme()
  },

  props: ['id'],

  data () {
    return {
      scheme: {
        plans:[]
      },
      permissions: [],
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
      newPlan:{
        name:null,
        contribution_frequency:null,
        amount:null
      },
      contribution_frequencies:[
        { value: "Ad hoc", text: 'Ad hoc - contributions are not fixed.' },
        { value: 'Monthly', text: 'Monthly - fixed amount every calendar month.' },
        { value: 'Annually', text: 'Annually - fixed amount every calendar year.' },
      ],
    }
  },

  methods: {
  
    async getScheme () {
      try {
        this.loading = true;
        let { data } = await schemeRepo.get(this.id)
        this.scheme = data.scheme

      } catch (error) {
        console.log(error)
      } finally{
        this.loading = false
      }
    },
    async handleSubmit () {
      this.loading = true
      this.submitStatus = 'PENDING'
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
        this.loading = false
      } else {
        try {
          await schemeRepo.update(this.id, this.scheme)
          this.$emit("schemeUpdated");
        } catch (error) {
          console.log(error)
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
            console.log(this.errors)
               this.$root.$bvToast.toast('Form Errors', {
                title: 'Errors on form data',
                autoHideDelay: 3000,
                variant: 'danger',
            })
          }
        } finally {
          this.loading = false
          this.submitStatus = null
        }
      }
    },


     addPlan(){
      if(this.newPlan.name == null || this.newPlan.contribution_frequency == null){
        this.$root.$bvToast.toast('Form Errors', {
                title: 'Errors on form data',
                autoHideDelay: 3000,
                variant: 'danger',
        });
        return false;
      }

      if(this.newPlan.contribution_frequency != 'Ad hoc' && this.newPlan.amount == null){
        this.$root.$bvToast.toast('Form Errors', {
                title: 'Errors on form data',
                autoHideDelay: 3000,
                variant: 'danger',
        });
        return false;
      }

      if(this.newPlan.contribution_frequency != 'Ad hoc'){
        this.newPlan.auto_generate_contribution = 1;
      }else{
         this.newPlan.auto_generate_contribution = 0;
      }

      this.scheme.plans.push(this.newPlan);
      this.newPlan = {
        name:null,
        contribution_frequency:null,
        amount:null
      }
    },

    removePlan(id){
      let plans = [];

      this.scheme.plans.forEach(p => {
        if(p.id != id){
          plans.push(p);
        }
      });

      this.scheme.plans = plans;
    },

    
  }
}
</script>

<style></style>
